import { RetailerApiClient } from '@/services/RetailerApiClient.js'

export default {
  getPurchaseOffers(query) {
    return RetailerApiClient.get('purchase-offers', { params: query })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getPurchaseOffer(id) {
    return RetailerApiClient.get('purchase-offers/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createPurchaseOffer(id, purchaseOffer) {
    return RetailerApiClient.put('purchase-offers/' + id, purchaseOffer)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  ignorePurchaseOffer(id) {
    return RetailerApiClient.delete('purchase-offers/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getPurchasePriceOfferWaitingProducts() {
    return RetailerApiClient.get('purchase-offers/get-price-offer-waiting-products')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
